import { createSlice } from '@reduxjs/toolkit';

const exampleSlice = createSlice({
    name: 'example',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        fetchExampleRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchExampleSuccess: (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        },
        fetchExampleFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    fetchExampleRequest,
    fetchExampleSuccess,
    fetchExampleFailure,
} = exampleSlice.actions;

export default exampleSlice.reducer;
